import TopBar from "./components/TopBar";
import HeroCover from "./components/HeroCover";
import Standfirst from "./components/Standfirst";
import Collections from "./components/Collections";
import ChannelIndex from "./components/ChannelIndex";
import WatchRoutes from "./components/WatchRoutes";
import KeywordIndex from "./components/KeywordIndex";
import ReaderNotes from "./components/ReaderNotes";
import SubmitBand from "./components/SubmitBand";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <TopBar />
      <main className="w-full">
        <HeroCover />
        <Standfirst />
        <Collections />
        <ChannelIndex />
        <WatchRoutes />
        <KeywordIndex />
        <ReaderNotes />
        <SubmitBand />
      </main>
      <SiteFooter />
    </div>
  );
}